import logger from "debug";
export const ns: Record<string, logger.Debugger> = {};
export default ns;